import { FlexContainer } from "@mindmemobile/mm-shared-global";
import React, { Component } from "react";
import { MediaModel } from "../../../shared/models";
// import YoutubeCover from '../../../../../../images/membership/youtube-cover.svg';
// import Demo1 from '../../../../../../images/common/demo-image-1.svg';
// import Demo2 from '../../../../../../images/common/demo-image-2.svg';
// import Demo3 from '../../../../../../images/common/demo-image-3.svg';

type IProps = {
  medias: MediaModel[];
};
export default class ItemMediaSection extends Component<IProps> {
  render() {
      if (!this.props.medias || this.props.medias.length === 0) return null;

      const images = this.props.medias.filter((m) => m.type === 'Image');

      if (images.length === 0) return null;
      return (
          <FlexContainer spacing={25} fxLayout="column" margin={images.length > 1 ? '0px 0px 30px' : '0px'}>
              <div>
                  <img src={images[0].fullURL} className="item-main-image" />
              </div>
              {images.length > 1 && (
                  <div>
                      <FlexContainer spacing={20} className="media-selectors">
                          {images.map((m, idx) => {
                              if (idx === 0) return null;
                              return <img key={idx} src={m.fullURL} />;
                          })}
                      </FlexContainer>
                  </div>
              )}
          </FlexContainer>
      );
  }
}
